import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ArticleService } from '../../services/article.service';
import { Blog } from 'src/app/models/article';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-article-details',
  templateUrl: './article-details.component.html',
  styleUrls: ['./article-details.component.css'],
})
export class ArticleDetailsComponent implements OnInit {
  article!: Blog;
  isLoading = true;
  language = 'ar';

  constructor(
    private route: ActivatedRoute,
    private articleService: ArticleService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.language = this.route.snapshot.paramMap.get('lang') ?? 'ar';

    if (id) {
      this.articleService.getArticleDetails(id).subscribe({
        next: (data) => {
          this.article = {
            ...data,
            imageUrl: environment.baseURL + data.imageUrl,
          };
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching article details:', err);
          this.isLoading = false;
        },
      });
    }
  }
}
